<template>
  <div>
    <section>
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="/about">線上訂購</a></li>
                <li class="active">訂購完成</li>
            </ol>
              <h4>您的訂購已完成，請至會員中心查詢訂購紀錄</h4>
              <center class="success_block">
                  <br/><br/>
                  <h4 class="success_product_title">您將獲得免費贈送活動</h4>
                  <section v-if="firstbuy==0">
                    <p class="success_description">
                    </p>
                  </section>
                  <h5 class="success_product_name">{{rowData.name}}</h5>

                  <div class="row">
                      <span class="label label-default">
                        馬上分享 : https://www.i80.com.tw/product/{{activityItem}}/{{UserId}}
                      </span>
                      <br/><br/>
                      <social-sharing :url="shareLink"
                        title="i80"
                        description="i80"
                        hashtags="i80"
                        inline-template>
                        <div>
                          <network network="facebook">
                            <i class="fab fa-facebook fa-2x"></i> Facebook
                          </network>
                          <network network="line">
                            <i class="fab fa-line fa-2x"></i> Line
                          </network>
                        </div>
                      </social-sharing>
                  </div>
                  <br/>

<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
  了解詳情
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">活動訊息</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <p>
        愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。<br/>
      </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">關閉</button>
        <!--
        <button type="button" class="btn btn-primary">Save changes</button>
        -->
      </div>
    </div>
  </div>
</div>
                  <br/>
              </center>

        </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Success',
  data () {
    return {
      rowData: {},
      shareLink: '',
      activityItem: ''
    }
  },
  mounted: function () {
    let activityItem = parseInt(localStorage.getItem('activityitem'))
    // console.log('activityItem:', activityItem)
    // if (activityItem > 0) {
    //   let products = localStorage.getItem('products')
    //   products = JSON.parse(products)
    //   let dd = products.filter(function (value) {
    //     console.log('check::' + value.id + '---' + activityItem)
    //     return value.id === activityItem
    //   })
    //   // 只取得第一筆
    //   this.rowData = dd[0]
    //   console.log('data:' + dd[0].id)
    // }
    let UserId = localStorage.getItem('userId')
    this.activityItem = activityItem
    this.shareLink = 'https://www.i80.com.tw/product/' + activityItem + '/' + UserId
  },
  methods: {
    ...mapActions([
      'CLEAR_FIRST_BUY'
    ])
  },
  computed: {
    ...mapGetters({
      UserId: 'getUserID',
      firstbuy: 'getFirstbuy'
    })
  }
}
</script>



// WEBPACK FOOTER //
// Success.vue?7eb23596